export default "/img/LA.708850a866152884bef73a9751950adc.png";